import React, { useContext } from "react";
import UserContext from "../context/userContext";

import "../App.css"; // Import the CSS for the cursor

const CustomCursor = () => {
  const {
    currentMouseX,
    currentMouseY,
    areaFocus,
    currentSize,
    currentColor,
    currentTool,
  } = useContext(UserContext);

  return (
    <div
      className={`relative customCursor border-[1px] border-black ${
        areaFocus ? "inline" : "hidden"
      }
                ${currentTool === "Eraser" ? "rounded-none" : "rounded-full"}`}
      style={{
        width: `${currentSize}px`,
        height: `${currentSize}px`,
        left: `${currentMouseX}px`,
        top: `${currentMouseY}px`,
        backgroundColor: `${currentTool === "Eraser" ? "#FFF" : currentColor}`,
      }}
    >
    </div>
  );
};

export default CustomCursor;
